import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Storage } from './services/storage.service';
import { TokenStorageService } from './security/token-storage-service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './security/token.interceptor';
import { ConfigService } from './services/config.service';
import { runtimeConfigFactory } from './services/runtime-config.factory';
import { environment } from '../../environments/environment';
import { CurrentUserService } from './services/current-user.service';
import { RuntimeConfigService } from './services/runtime-config';
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    CurrentUserService,
    Storage,
    TokenStorageService,
    ConfigService,
    TokenStorageService,
    RuntimeConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: runtimeConfigFactory(environment),
      multi: true,
      deps: [RuntimeConfigService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
